import { Directive, Input } from '@angular/core';
import { MyNoosProductModel } from '@epicuro-next/models/products';
import { DeliveryItems } from '@epicuro-next/state/config-strip-state';
import { Prepack, Product, ScaleSets } from 'graphql-api/gql-api-interfaces';

@Directive()
export abstract class BaseGrid {
  @Input()
  public quantities?: DeliveryItems | { [sizeId: string]: unknown }; // quantities

  @Input()
  public products: Product[] | Prepack[] | MyNoosProductModel[] = []; //

  @Input()
  public scaleSets?: ScaleSets;

  @Input()
  public selectedScale?: string;

  @Input()
  public differentMaterialDimensions = false;

  public abstract buildGrid(): void;
}
